import { useCallback } from 'react';
import { useSafeNavigation, useSafeRouter } from '@sg/garnish';

import { useIsExpoRouterEnabled } from '@order/shared/hooks';

export const useRequestLogin = () => {
  const isExpoRouterEnabled = useIsExpoRouterEnabled();
  const navigation = useSafeNavigation();
  const router = useSafeRouter();

  const requestLogin = useCallback(() => {
    if (isExpoRouterEnabled) {
      router?.navigate({
        pathname: '/(auth)/join-or-sign-in',
        params: { redirect: 'bag' },
      });
      return;
    }

    navigation?.navigate('Auth', {
      screen: 'Login',
      params: { redirect: 'bag' },
    });
  }, [isExpoRouterEnabled, navigation, router]);

  return { requestLogin };
};
